<div class="entries-header">
  <p class="results-msg">{{resultsMsg()}}</p>
</div>
<div class="entries-grid">
  <ng-container *ngFor="let e of featuredEntries.concat(pagedEntries); let i = index; let l = last">
    <div *ngIf="i === featuredCount" class="ent-all-header">
      <h3>More posts:</h3>
    </div>
    <div [class]="'entry' + addClass(i)" [@paginateState]="activePage">
      <app-entry-card [entry]="e" [entryClass]="addClass(i)" (open)="open($event)"></app-entry-card>
    </div>
    <nav *ngIf="l && i > featuredEntries.length - 1 && pages.length > 1" class="pagination">
      <a *ngFor="let p of pages" [class]="'button primary' + (p === activePage ? ' active' : '')" (click)="getPaged(p, $event)">{{p}}</a>
    </nav>
  </ng-container>
</div>
